<template>
	<span class="flex items-center px-2 py-1 rounded">
		<div
			class="h-3 w-3 rounded-full mr-2"
			:style="{
				backgroundColor: chipColor(params.value),
			}"
		></div>
		<span style="font-size: 13px">{{ params.value }}</span>
	</span>
</template>

<script>
export default {
	name: "CellRendererTypeRouting",
	computed: {
		chipColor() {
			return (value) => {
				if (value === "GMPRO") return "#3D79B8";
				else if (value === "OPENROUTE") return "#b5152b";
				else if (value === "TOUR_PLANNING") return "#30b59a";
				else return "secondary";
			};
		},
	},
};
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
	&.vs-chip-success {
		background: rgba(var(--vs-success), 0.15);
		color: rgba(var(--vs-success), 1) !important;
		font-weight: 500;
	}
	&.vs-chip-warning {
		background: rgba(var(--vs-warning), 0.15);
		color: rgba(var(--vs-warning), 1) !important;
		font-weight: 500;
	}
	&.vs-chip-danger {
		background: rgba(var(--vs-danger), 0.15);
		color: rgba(var(--vs-danger), 1) !important;
		font-weight: 500;
	}
}
</style>
